import { createRef, Component } from "react";
import Radio from "backbone.radio";
import Backbone from "extensions/backbone";
import { ToastContainer } from "extensions/toast";
import { captureBreadcrumb } from "extensions/sentry";
import { MarionetteToReact } from "extensions/MarionetteToReact";

import { ensureErrorCallback, ErrorView } from "common/components/error";
import { NavigatorOnline } from "common/components/navigatorOnline";
import { AppLayout } from "common/layouts/appLayout";

export class MerchantApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null
        };
        
        this.mnLayout = createRef();
    }
    
    async componentDidMount() {
        try {
            Radio.channel("app").reply("error:show", this.showError.bind(this));
            Radio.channel("app").reply("get:layout", () => {
                if (this.state.error) {
                    return null;
                }
    
                return this.mnLayout.current.marionetteView;
            });
            
            const { security } = await import("common/components/security");
            this.security = security;
            
            // Create auth router
            const { LoginRouter } = await import("common/features/login/loginRouter");
            const { LoginController } = await import("common/features/login/loginController");
            this.loginRouter = new LoginRouter({
                controller: new LoginController()
            });
            
            // Create merchant router
            const { MerchantController } = await import("./controller");
            const { MerchantRouter } = await import("./router");
            this.merchantRouter = new MerchantRouter({
                controller: new MerchantController()
            });
            
            Backbone.history.start({
                pushState: true,
                root: "/merchant"
            });
        } catch (error) {
            captureBreadcrumb({
                message: "Caught error at app's componentDidMount",
                data: {
                    error
                }
            });
            
            if (error.name === "ChunkLoadError") {
                ensureErrorCallback(error, () => this.showError(error));
            } else {
                this.showError(error);
            }
        }
    }
    
    componentWillUnmount() {
        Radio.channel("app").off().stopReplying();
    }
    
    showError(error) {
        this.setState({
            error
        });
    }
    
    render() {
        if (this.state.error) {
            return <ErrorView error={this.state.error}/>;
        }
        
        return (
            <>
                <MarionetteToReact className="marionette-app-wrapper" ref={this.mnLayout} View={AppLayout}/>
                <ToastContainer />
                <NavigatorOnline/>
            </>
        );
    }
}
